import { Api } from "./classes/Api";
import { Course } from "./classes/Course";

const api = new Api();
const outline = document.querySelector("main") as HTMLElement;
api.getItem(121, courseFetched);

function courseFetched(data: ICourse) {
  if (data && data.data && data.children && Array.isArray(data.children) && outline) {
    const course = new Course(data, outline);
  } else {
    console.error("Invalid data format:", data);
  }
}